import { METRICS } from './constants';
import { publishClientSideMetrics, publishCustomMetrics } from '../handler/parentDataHandler';
import { getStationCode } from '../utils/networkUtil';

export const METRIC_PROCESS = 'SCC_SHIFTPLAN';
export const METRIC_PROCESS_LABOR_ALLOCATION = 'SCC_LABOR_ALLOCATION_PLAN';

export const CALL_METHODS = {
  GET_ALL_PLANS: 'getAllPlans',
  CREATE_PLAN: 'createPlan',
  GET_PLAN: 'getPlan',
  UPDATE_PLAN_STATUS: 'updatePlanStatus',
  UPDATE_OUTPUT: 'updateOutput'
};

export const LABOR_ALLOCATION_METRICS = {
  REMOVE_ALL_ASSOCIATES: 'removeAllAssociates',
  REMOVE_CLOCKED_OUT_ASSOCIATES: 'removeClockedOutAssociates',
  RERUN_ALLOCATION_PLAN: 'rerunAllocationPlan',
  SAVE_ALLOCATION_BOARD: 'saveAllocationBoard',
  TRACK_INTO_FCLM: 'trackIntoFCLM'
};

export const publishCount = (processName, metricName) => {
  const request = getMetricPublishRequest(processName, metricName, 1, METRICS.COUNT);
  publishClientSideMetrics(request);
};

export const publishTime = (processName, metricName, startTime) => {
  const metricValue = Date.now() - startTime;
  const request = getMetricPublishRequest(processName, metricName, metricValue, METRICS.TIME);
  publishClientSideMetrics(request);
};

const getMetricPublishRequest = (processName, metricName, metricValue, metricType) => {
  return {
    processName,
    metricName,
    metricValue,
    metricType
  };
};

export function logCustomMetrics(eventType, eventName) {
  let stationCode = getStationCode();
  publishCustomMetrics({
    eventType: eventType,
    eventName: eventName,
    stationCode: stationCode
  });
}

export const publishLaborAllocationCountMetric = (metricName) => {
  const stationCode = getStationCode();

  // Publish overall metric
  publishCount(METRIC_PROCESS_LABOR_ALLOCATION, metricName);

  // Publish station-level metric
  const stationProcessName = `${METRIC_PROCESS_LABOR_ALLOCATION}_${stationCode}`;
  publishCount(stationProcessName, metricName);
};
